import {
  Modal,
  SpaceBetween,
  Container,
  Button,
  Grid,
  Box,
  Icon,
} from "@amzn/awsui-components-react";
import { TestCase, UATStatus } from "../../types/UATProject";
import { SummaryItem } from "../summary/SummaryItem";

interface TestCaseSummaryModalProps {
  visible: boolean;
  onDismiss: () => void;
  testCase: TestCase | null;
}

export function TestCaseSummaryModal({
  visible,
  onDismiss,
  testCase,
}: TestCaseSummaryModalProps) {
  if (!testCase) {
    return null;
  }

  const formatValue = (value: any): string => {
    if (value === null || value === undefined) {
      return "-";
    }
    if (typeof value === "object") {
      return JSON.stringify(value);
    }
    return String(value);
  };

  return (
    <Modal
      visible={visible}
      onDismiss={onDismiss}
      header={testCase.name}
      size="large"
      footer={
        <Button variant="primary" onClick={onDismiss}>
          Close
        </Button>
      }
    >
      <SpaceBetween size="l">
        <Container header={<h2>Basic Information</h2>}>
          <SpaceBetween size="l">
            <Grid
              gridDefinition={[
                { colspan: 5 }, // Left column - 4 columns wide
                { colspan: 7 }, // Right column - 8 columns wide
              ]}
            >
              <SpaceBetween size="l">
                <SummaryItem label="Name" value={testCase.name} />
                <SummaryItem
                  label="Status"
                  value={UATStatus[testCase.status]}
                />
                <SummaryItem label="Orders" value={testCase.order.id} />
              </SpaceBetween>
              <SpaceBetween size="m">
                <div style={{ height: "300px", overflowY: "auto" }}>
                  {testCase.history && testCase.history.length > 0 ? (
                    testCase.history
                      // @ts-ignore
                      .filter((entry) => {
                        // comments can arrive as a JSON string or an array
                        const comments = entry.comments as unknown;
                        if (!comments) return false;
                        return Array.isArray(comments)
                          ? comments.length > 0
                          : comments !== "[]";
                      })
                      .map((entry, index) => {
                        const comments =
                          typeof entry.comments === "string"
                            ? JSON.parse(entry.comments)
                            : entry.comments;

                        return (
                          Array.isArray(comments) &&
                          comments.map((comment, commentIndex) => (
                            <Box
                              key={`${index}-${commentIndex}`}
                              margin={{ bottom: "s" }}
                              padding="s"
                            >
                              <SpaceBetween size="xs">
                                <div
                                  style={{
                                    fontSize: "14px",
                                    color: "#666",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "8px",
                                  }}
                                >
                                  <Icon name="user-profile-active" />
                                  <span>{comment.user}</span>
                                  <span style={{ marginLeft: "auto" }}>
                                    {new Date(entry.runDate).toLocaleString()}
                                  </span>
                                </div>
                                <div style={{ wordBreak: "break-word" }}>
                                  {comment.comment}
                                </div>
                              </SpaceBetween>
                            </Box>
                          ))
                        );
                      })
                  ) : (
                    <Box color="text-status-inactive" textAlign="center">
                      No comments available
                    </Box>
                  )}
                </div>
              </SpaceBetween>
            </Grid>
          </SpaceBetween>
        </Container>
      </SpaceBetween>
    </Modal>
  );
}
